import React, { Component } from 'react';

// The navigational component of the site
class Navigation extends Component {
  render() {
    let navLinks = [];
    for (const [key] of Object.entries(this.props.sections)) {
      navLinks.push(
        <div key={key}><a href={"/" + key} onClick={this.props.onSectionChange.bind(this, key)} >{key}</a></div>
      );
    }

    return (
      <div>
        {navLinks}
      </div>
    );
  }
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/Navigation.js